import {  createSlice } from "@reduxjs/toolkit";

// create slice
const name = "system";
const initialState = createInitialState();
const reducers = createReducers();
const extraActions = createExtraActions();
// const action = createAction();
const extraReducers = createExtraReducers();
const slice = createSlice({ name, initialState, reducers, extraReducers });

// exports

export const systemActions = {
  ...slice.actions,
  ...extraActions,
  // ...action,
};
export const systemReducer = slice.reducer;
// implementation

function createInitialState() {
  return {
    isLoading: false,
  };
}

function createReducers() {
  return {
    setLoadingSystem,
  };

  function setLoadingSystem(state, action) {
    state.isLoading = action.payload;
  }
}

function createExtraActions() {
  return {};
}

function createExtraReducers() {
  return {};
}
